import { handleAwsError } from "./awsErrorHandler";
import { ADMIN_ACTIONS } from "./cognitoAdminService";
import { cognitoClientProviderForAmplify, cognitoConfigJSON, DEFAULT_EMAIL_VERIFY, ROLES, USER_ATTRIBUTES } from "./cognitoClientProviderHelper";
import {
    AdminGetUserCommand,
    ListUsersCommand,
    AdminCreateUserCommand,
    SignUpCommand,
    AdminDeleteUserCommand,
    AdminEnableUserCommand,
    AdminDisableUserCommand,
    AdminConfirmSignUpCommand,
    AdminSetUserPasswordCommand,
    AdminResetUserPasswordCommand,
    AdminUpdateUserAttributesCommand,
} from '@aws-sdk/client-cognito-identity-provider';


export const signUpUserInPoolAmplify = async (userDataDetail, ACTION, email, temporaryPassword, Role) => {
    console.log("userDataDetail : ",userDataDetail)
    if (userDataDetail) {
        const _cognitoClientProviderForAmplify = await cognitoClientProviderForAmplify(userDataDetail);
        var adminActionCommand = null;

        switch (ACTION) {
            case ADMIN_ACTIONS.LIST_USERS:
                //List Users
                adminActionCommand = new ListUsersCommand({
                    UserPoolId: cognitoConfigJSON.userPoolId,
                    //Filter: 'custom:role = "admin"',
                    // AttributesToGet: ['email'],
                    // Limit: 60,
                });
                break;

            case ADMIN_ACTIONS.CREATE_USER:
                //Create User
                adminActionCommand = new AdminCreateUserCommand({
                    UserPoolId: cognitoConfigJSON.userPoolId,
                    Username: email,
                    TemporaryPassword: temporaryPassword || "nexIntain@1234",
                    UserAttributes: [
                        { Name: USER_ATTRIBUTES.EMAIL, Value: email },
                        { Name: USER_ATTRIBUTES.EMAIL_VERIFIED, Value: DEFAULT_EMAIL_VERIFY },
                        { Name: USER_ATTRIBUTES.ROLE, Value: Role || ROLES.SUPER_ADMIN }
                    ],
                    MessageAction: "SUPPRESS",
                });
                break;

            case ADMIN_ACTIONS.DELETE_USER:
                //Delete User
                adminActionCommand = new AdminDeleteUserCommand({
                    UserPoolId: cognitoConfigJSON.userPoolId,
                    Username: email,
                });
                break;

            case ADMIN_ACTIONS.USER_ATTRIBUTES:
                //Get User Info
                adminActionCommand = new AdminGetUserCommand({
                    UserPoolId: cognitoConfigJSON.userPoolId,
                    Username: email,
                });
                break;

            case ADMIN_ACTIONS.CONFIRM_USER:
                //Update User Confirmation Status
                adminActionCommand = new AdminConfirmSignUpCommand({
                    UserPoolId: cognitoConfigJSON.userPoolId,
                    Username: email,
                });
                break;

            case ADMIN_ACTIONS.ENABLE_USER:
                //Update User Status Enable
                adminActionCommand = new AdminEnableUserCommand({
                    UserPoolId: cognitoConfigJSON.userPoolId,
                    Username: email,
                });
                break;

            case ADMIN_ACTIONS.DISABLE_USER:
                //Update User Status Disable
                adminActionCommand = new AdminDisableUserCommand({
                    UserPoolId: cognitoConfigJSON.userPoolId,
                    Username: email,
                });
                break;

            case ADMIN_ACTIONS.UPDATE_USER:
                //Update User Attributes
                adminActionCommand = new AdminUpdateUserAttributesCommand({
                    UserPoolId: cognitoConfigJSON.userPoolId,
                    Username: email,
                    UserAttributes: [
                        { Name: USER_ATTRIBUTES.EMAIL_VERIFIED, Value: DEFAULT_EMAIL_VERIFY },
                        { Name: USER_ATTRIBUTES.ROLE, Value: Role || ROLES.SUPER_ADMIN },
                    ],
                });
                break;

            case ADMIN_ACTIONS.SET_USER_PASSWORD:
                //Add User Password (Status:Force Change Password => Status:Confirmed)
                adminActionCommand = new AdminSetUserPasswordCommand({
                    UserPoolId: cognitoConfigJSON.userPoolId,
                    Username: email,
                    Password: temporaryPassword,
                    Permanent: true
                });
                break;

            case ADMIN_ACTIONS.RESET_USER_PASSWORD:
                //Reset User Password
                adminActionCommand = new AdminResetUserPasswordCommand({
                    UserPoolId: cognitoConfigJSON.userPoolId,
                    Username: email,
                });
                break;

            default:
                break;
        }

        if (adminActionCommand && ACTION) {
            try {
                const response = await _cognitoClientProviderForAmplify.send(adminActionCommand);
                console.log("Admin Cognito Actions Response : ", response);
                
                // const enabledAdmins = response.Users.filter(
                //   user => user.Enabled === true && user.UserStatus !== "DISABLED"
                // );
                return response;
            } catch (error) {
                // {
                //     "name": "UsernameExistsException",
                //     "$fault": "client",
                //     "$metadata": {
                //       "httpStatusCode": 400,
                //       "requestId": "f5f3b38e-e56d-4907-a8ed-8b98d2011bc9",
                //       "attempts": 1,
                //       "totalRetryDelay": 0
                //     },
                //     "__type": "UsernameExistsException"
                // }
                console.log("Admin Cognito Actions Error : ", error);
                console.error("Admin Cognito Actions Error : ", handleAwsError(error));
                return {isError:true,error:error};
            }
        }
    }
};
